<template>
    <section>
        <h4 style="font-weight: 800; padding-bottom: 6px">
            {{ $t('mensagens.territorio.territorioAr.titulo') }}
        </h4>

        <el-card>
            <el-form
                :model="form"
                :rules="rules"
                ref="fields"
                label-position="top"
            >
                <h4 style="font-weight: 600; color: #3b3b3b; margin-top: 15px">
                    {{ $t('mensagens.territorio.territorioAr.datos') }}
                </h4>
                <el-form-item
                    prop="nome"
                    key="form.nome"
                    :label="$t('mensagens.territorio.territorioAr.fazenda')"
                >
                    <el-input
                        v-model="form.nome"
                        :placeholder="
                            $t('mensagens.territorio.territorioAr.fazenda')
                        "
                    ></el-input>
                </el-form-item>
                <h4 style="font-weight: 600; color: #3b3b3b; margin-top: 15px">
                    {{ $t('mensagens.territorio.territorioAr.localizacao') }}
                </h4>
                <el-row :gutter="20">
                    <el-col :span="8">
                        <el-form-item
                            prop="cuit"
                            :label="$t('mensagens.territorio.labels.cuit')"
                            key="form.cuit"
                        >
                            <div class="flex">
                                <input
                                    type="hidden"
                                    v-model="form.cuit"
                                    v-mask="'##-########-#'"
                                />
                                <el-input
                                    :placeholder="
                                        $t(
                                            'mensagens.territorio.labels.selecione'
                                        )
                                    "
                                    v-mask="'##-########-#'"
                                    v-model="form.cuit"
                                >
                                    <i
                                        slot="prefix"
                                        class="el-input__icon el-icon-search"
                                    ></i>
                                </el-input>
                                <!-- <el-button
                                    type="primary"
                                    icon="el-icon-search"
                                    style="margin-left: 15px"
                                ></el-button> -->
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item
                            prop="provincia"
                            :label="$t('mensagens.territorio.labels.provincia')"
                        >
                            <el-input
                                disabled
                                v-model="form.provincia"
                                :placeholder="
                                    $t('mensagens.territorio.labels.provincia')
                                "
                                style="width: 100%"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="8">
                        <el-form-item
                            prop="renspa"
                            :label="$t('mensagens.territorio.labels.renspa')"
                        >
                            <input
                                type="hidden"
                                v-model="form.renspa"
                                v-mask="'##.###.#.#####/##'"
                            />
                            <el-input
                                v-model="form.renspa"
                                :placeholder="
                                    $t('mensagens.territorio.labels.renspa')
                                "
                                style="width: 100%"
                                v-mask="'##.###.#.#####/##'"
                                @input="buscarProvincia"
                            />
                        </el-form-item>
                    </el-col>
                </el-row>
                <informacao-agricula
                    @update="addInformation"
                    :options="form.informacoesAgricolas"
                    :cultivos="cultivo"
                    @delete="deleteInformation"
                />
            </el-form>
        </el-card>
    </section>
</template>
<script>
import InformacaoAgricula from './InformacaoAgriculaAr.vue';
import { validateCuit } from '@/utils/validations/cuit';
import TerritorioService from '@/services/TerritorioService';

export default {
    props: {
        optionsRespa: {
            type: Array,
            default: () => []
        },
        optionsProvincia: {
            type: Array,
            default: () => []
        },
        cultivo: {
            type: Array,
            default: () => []
        },
        fields: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        const validationDocument = (_, value, callback) => {
            if (!validateCuit(value)) {
                callback(this.$t('mensagens.pessoas.cuitErro'));
            } else {
                callback();
            }
        };
        return {
            form: {
                nome: '',
                cuit: '',
                provincia: '',
                renspa: '',
                informacoesAgricolas: []
            },

            prevRenspa: '',

            rules: {
                nome: [
                    {
                        required: true,
                        message: this.$t(
                            'mensagens.territorio.preenchaCampoObrigatorio'
                        ),
                        trigger: ['blur', 'change']
                    }
                ],
                cuit: [
                    {
                        required: true,
                        message: this.$t(
                            'mensagens.territorio.preenchaCampoObrigatorio'
                        ),
                        trigger: ['blur', 'change']
                    },
                    {
                        validator: validationDocument,
                        trigger: ['blur', 'change']
                    }
                ],
                provincia: [
                    {
                        required: true,
                        message: this.$t(
                            'mensagens.territorio.preenchaCampoObrigatorioProvincia'
                        ),
                        trigger: ['blur', 'change']
                    }
                ],
                renspa: [
                    {
                        required: true,
                        message: this.$t(
                            'mensagens.territorio.preenchaCampoObrigatorio'
                        ),
                        trigger: ['blur', 'change']
                    }
                ]
            }
        };
    },
    components: {
        InformacaoAgricula
    },

    watch: {
        form: {
            handler: function (value) {
                this.$refs['fields'].validate(async valid => {
                    if (valid && value.informacoesAgricolas.length > 0) {
                        this.$emit('update', value);
                        this.$emit('validate', true);
                    } else {
                        this.$emit('validate', false);
                    }
                });
            },
            deep: true
        },
        fields: {
            handler(value) {
                if (!value || Object.keys(value).length === 0) return;
                this.$nextTick(() => {
                    this.form.nome = value.nome;
                    this.form.cuit = value.cuit;
                    this.form.provincia = value.provincia;
                    this.form.renspa = value.renspa;
                    this.form.informacoesAgricolas =
                        value.informacoesAgricolas || [];
                });
            },
            deep: true
        }
    },
    methods: {
        addInformation(value) {
            this.form.informacoesAgricolas.push(value);
        },
        deleteInformation(index) {
            this.form.informacoesAgricolas.splice(index, 1);
        },
        async buscarProvincia() {
            if (this.form.renspa.length < 2) {
                this.form.provincia = '';
                this.prevRenspa = '';
                return;
            };
            const codigoExtraido = this.form.renspa.slice(0, 2);

            if (codigoExtraido === this.prevRenspa) {
            // Se não mudou, não faz a requisição
                return;
            }

            this.prevRenspa = codigoExtraido;

            try {
                const { data } = await TerritorioService.obterProvinciaPorCodigoArgentina(
                    codigoExtraido
                );
                this.form.provincia = data;
            } catch (error) {
                this.form.provincia = '';
                this.prevRenspa = '';

                if (error?.response?.status === 404) {
                    this.$notify.error({
                        message: this.$t('mensagens.territorio.erroMensagem.provinciaNaoEncontrada')
                    });
                }
            }
        }
    }
};
</script>
